import type { RouteRecordRaw } from "vue-router";

const miscRoutes: RouteRecordRaw[] = [
  {
    path: "/contact",
    alias: "/contact-us",
    name: "contact",
    component: () => import("@/views/Contact/ContactUs.vue"),
    meta: {
      title: "Contact Us",
      requiresAuth: true,
      miscPermission: "contact",
    },
  },
  {
    path: "/licenses",
    alias: "/licenses/view",
    name: "licenses",
    component: () => import("@/views/Licenses/ViewLicenses.vue"),
    meta: {
      title: "View Licenses",
      requiresAuth: true,
      miscPermission: "licenses",
    },
  },
  {
    path: "/fieldalytics",
    alias: "/fieldAlytics/sso",
    name: "fieldalytics",
    component: () => import("@/views/FieldAlytics/FieldAlyticsSSOPage.vue"),
    meta: {
      title: "FieldAlytics",
      requiresAuth: true,
      miscPermission: "fieldAlytics",
    },
  },
  {
    path: "/install-app-how-to",
    name: "install-app-how-to",
    component: () => import("@/views/ProgressiveWebApp/InstallAppHowToPage.vue"),
    meta: {
      title: "Install App",
      skipAuth: true,
    },
  },
];

export default miscRoutes;
